module.exports = __webpack_public_path__ + "static/media/welcome@2x.a1a0e049.png";